// Shared activity types configuration
export const activityTypeValues = [
  "running",
  "cycling", 
  "crossCountrySkiing",
  "rowing",
  "elliptical",
  "swimming",
  "other"
];

// Helper function to get activity label using translations
export function getActivityLabel(value, _) {
  const translationKey = `sessions.form.endurance.activityTypes.${value}`;
  return _(translationKey) || value;
}
